import { useFormContext } from "react-hook-form";

import TextField from "./text-field";

import { validation } from "../../Utils/validations";

export default function EmailField(props) {
  const { register, formState, getFieldState } = useFormContext();

  const emailFieldProps = register("email", {
    required: "Please enter your email address",
    validate: {
      isAValidEmail: (email) => validation.email.isAValidEmail(email) || "Please enter a valid email address",
      hasAtmost254Characters: (email) =>
        validation.email.hasAtmost254Characters(email) || "Your email address must be 254 characters or less",
    },
  });

  const { error: emailFieldError } = getFieldState(emailFieldProps.name, formState);

  return (
    <TextField
      {...emailFieldProps}
      label="Email"
      autoFocus
      errorMessage={emailFieldError?.message}
      error={!!emailFieldError}
      {...props}
    />
  );
}
